/* Squishit — A · Candy Block behaviour.
   Shopify port of a.html's inline script. Everything the shopper sees is
   rendered by Liquid from the live store; this file only adds behaviour:
   · bag: /cart/add.js + /cart/change.js, and the drawer comes back from the
     Section Rendering API (section "sq-cart-drawer"), never built here
   · grid: shape chips filter, colour dots swap a card in place, quick add
   · set builder, product page (qty, colour swap in place, Photo/3D)
   · hero: the 3D squishy, loaded lazily (poster first) from sq-squish.js
   No dependency, no framework; runs as a classic deferred script. */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var SQ = window.SQ || {};
  var R = SQ.routes || {};
  var body = d.body;
  var onCartPage = body.classList.contains('template--cart');
  var soundOn = true;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* money, only for numbers this script has to compute (qty × price, set total).
     Every other price on the page is Liquid's. The prefix is read off a
     Liquid-formatted price, so it is the store's own currency glyph. */
  var moneyPrefix = '₹';
  var fmt = function (cents) { return moneyPrefix + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }); };

  /* ---------------------------------------------------------------- toast */
  var tt;
  function toast(t) {
    var el = $('#toast'); if (!el) return;
    el.textContent = t; el.classList.add('on');
    clearTimeout(tt); tt = setTimeout(function () { el.classList.remove('on'); }, 2200);
  }

  /* ---------------------------------------------------------------- bag */
  var DRAWER = 'sq-cart-drawer';
  function post(url, data) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong — please try again.');
          return j;
        });
      });
  }
  function setCount(n) {
    var b = $('#cartN'); if (b) b.textContent = n;
    var btn = $('#cartBtn'); if (btn) btn.setAttribute('aria-label', 'Open bag, ' + n + ' items');
  }
  function bump() {
    var b = $('#cartBtn'); if (!b) return;
    b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump');
  }
  function swapDrawer(html) {
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cartWrap');
    var cur = $('#cartWrap');
    if (fresh && cur) cur.parentNode.replaceChild(fresh, cur);
    if (fresh) setCount(+fresh.getAttribute('data-count') || 0);
  }
  function add(items, opts) {
    opts = opts || {};
    return post(R.cartAdd + '.js', { items: items, sections: DRAWER, sections_url: location.pathname })
      .then(function (res) {
        if (onCartPage) { location.reload(); return res; }
        swapDrawer(res.sections && res.sections[DRAWER]);
        bump();
        if (!opts.quiet) {
          var it = res.items && res.items[0];
          toast(opts.msg || ((it && it.product_title ? it.product_title : 'Item') + ' added'));
        }
        return res;
      })
      .catch(function (e) { toast(e.message); throw e; });
  }
  function change(line, q) {
    return post(R.cartChange + '.js', { line: +line, quantity: +q, sections: DRAWER, sections_url: location.pathname })
      .then(function (res) { swapDrawer(res.sections && res.sections[DRAWER]); })
      .catch(function (e) { toast(e.message); });
  }
  var lastFocus = null;
  function openCart(on) {
    body.classList.toggle('open', on);
    var dr = $('.drawer');
    if (on) { var tst = $('#toast'); if (tst) tst.classList.remove('on'); lastFocus = d.activeElement; if (dr) setTimeout(function () { dr.focus(); }, 50); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    var c = t.closest('#cartBtn');
    if (c && !onCartPage) { e.preventDefault(); openCart(true); return; }
    if (t.closest('#closeCart') || t.closest('#scrim')) { openCart(false); return; }
    var q = t.closest('#cartWrap [data-q]');
    if (q) { e.preventDefault(); change(q.getAttribute('data-d') || q.getAttribute('data-i'), q.getAttribute('data-q')); return; }
    if (t.closest('#burger')) { $('#sheet').classList.add('on'); $('#burger').setAttribute('aria-expanded', 'true'); return; }
    if (t.closest('#sheetX') || t.closest('#sheet a')) { $('#sheet').classList.remove('on'); var bg = $('#burger'); if (bg) bg.setAttribute('aria-expanded', 'false'); }
  });
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (body.classList.contains('open')) openCart(false); var s = $('#sheet'); if (s) s.classList.remove('on'); }
  });

  /* quick add on cards: a real form, upgraded */
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-addform]');
    if (!f) return;
    e.preventDefault();
    var btn = $('.add', f); if (!btn || btn.disabled) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    add([{ id: +f.elements.id.value, quantity: 1 }]).then(function () {
      btn.classList.add('done'); btn.textContent = 'Added ✓';
      setTimeout(function () { btn.classList.remove('done'); btn.innerHTML = label; btn.disabled = false; }, 1400);
    }, function () { btn.disabled = false; });
  });

  /* ---------------------------------------------------------------- grid */
  var grid = $('#grid'), chips = $('#chips');
  if (grid) {
    var pristine = {}, filter = 'All';
    /* snapshots as HTML strings, not cloneNode: a detached clone of an <img>
       starts downloading at once, which defeated loading="lazy" for all 59 */
    $$('.card', grid).forEach(function (c) { pristine[c.getAttribute('data-h')] = c.outerHTML; });
    if (chips) chips.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s]'); if (!b) return;
      filter = b.getAttribute('data-s');
      $$('[data-s]', chips).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      $$('.card', grid).forEach(function (c) { c.hidden = filter !== 'All' && c.getAttribute('data-shape') !== filter; });
    });
    grid.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-sw]'); if (!sw) return;
      var h = sw.getAttribute('data-sw'), src = pristine[h];
      if (!src) return; /* sibling not on this page: follow the link */
      e.preventDefault();
      var tpl = d.createElement('template'); tpl.innerHTML = src;
      var card = sw.closest('.card'), fresh = tpl.content.firstElementChild;
      fresh.hidden = card.hidden;
      card.parentNode.replaceChild(fresh, card);
      var dot = $('[data-sw="' + h + '"]', fresh); if (dot) dot.focus();
    });
  }

  /* ---------------------------------------------------------------- 3D */
  /* sq-squish.js is a classic script exposing window.SQSquish, injected on
     demand. Not import(): Shopify's minifier rewrites import() in theme JS
     into require(), which does not exist in a browser. */
  var squishP = null;
  function squish() {
    if (!squishP) squishP = new Promise(function (res, rej) {
      if (window.SQSquish) return res(window.SQSquish);
      var s = d.createElement('script');
      s.src = SQ.squish; s.async = true;
      s.onload = function () { window.SQSquish ? res(window.SQSquish) : rej(new Error('3D engine missing')); };
      s.onerror = function () { rej(new Error('3D engine failed to load')); };
      d.head.appendChild(s);
    }).then(function (m) { m.setModels(SQ.models || {}); return m; }, function (e) { squishP = null; throw e; });
    return squishP;
  }

  /* ---------------------------------------------------------------- hero */
  var stage = $('#heroStage'), heroData = $('#heroData');
  var hero = null;
  if (stage && heroData) (function () {
    var hd = JSON.parse(heroData.textContent);
    var toyKey = stage.getAttribute('data-toy'), heroH = stage.getAttribute('data-h');
    var play = $('.hero-play'), poster = $('.poster', stage);
    var heroBg = (hd.toys[toyKey] || {}).bg || '#ffd6ea';
    var initing = false;
    var vOf = function (h) { for (var k in hd.toys) { var vs = hd.toys[k].variants; for (var i = 0; i < vs.length; i++) if (vs[i].h === h) return vs[i]; } return null; };
    function paint() {
      play.style.background = heroBg;
      if (hero) { hero.setVariant(heroH); hero.setBg(heroBg); }
      else if (poster) { var v = vOf(heroH); if (v && v.cut) poster.src = v.cut; }
    }
    function heroSw() {
      var vs = (hd.toys[toyKey] || {}).variants || [], p = vOf(heroH) || vs[0];
      var sws = $('#sws'); sws.textContent = '';
      if (vs.length > 1) vs.forEach(function (v) {
        var b = d.createElement('button');
        b.type = 'button'; b.style.background = v.hex || v.tint; b.title = v.colour;
        b.setAttribute('aria-label', v.colour); b.setAttribute('aria-pressed', v.h === heroH); b.setAttribute('data-v', v.h);
        sws.appendChild(b);
      });
      var l = d.createElement('span'); l.className = 'swl'; l.textContent = p ? p.colour : ''; sws.appendChild(l);
      if (p) $('#toyLink').href = p.url;
    }
    $('#toyRow').addEventListener('click', function (e) {
      var b = e.target.closest('[data-k]'); if (!b) return;
      toyKey = b.getAttribute('data-k');
      var t = hd.toys[toyKey];
      heroH = vOf(t.lead) ? t.lead : t.variants[0].h; heroBg = t.bg;
      $$('[data-k]', this).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      paint(); heroSw();
    });
    $('#sws').addEventListener('click', function (e) {
      var b = e.target.closest('[data-v]'); if (!b) return;
      heroH = b.getAttribute('data-v'); heroBg = (vOf(heroH) || {}).tint || heroBg;
      paint(); heroSw();
    });
    function init3d() {
      if (hero || initing) return; initing = true;
      squish().then(function (m) {
        hero = m.createSquishy(stage, {
          toy: m.toyForHandle(heroH), variant: heroH, bg: heroBg, zoom: 0.78, lift: 0.28, sound: soundOn,
          onSquish: function (n) { $('#sqN').textContent = n; $('#hint').style.opacity = 0; },
          onReady: function () { stage.classList.add('ready'); },
          onError: function () { stage.classList.remove('ready'); }
        });
        stage.classList.add('live');
      }).catch(function (e) { initing = false; if (window.console) console.warn('Squishit 3D:', e && e.message); });
    }
    /* phones and slow links: poster first, 3D after the page has loaded and
       the browser is idle — or immediately on a touch of the stage */
    heroSw();
    stage.addEventListener('pointerdown', init3d, { once: true });
    var saveData = navigator.connection && navigator.connection.saveData;
    var whenIdle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 600); })(init3d, { timeout: 2500 }); };
    if (!saveData) {
      var go = function () {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); whenIdle(); } }, { rootMargin: '200px' });
        io.observe(stage);
      };
      /* after load — but never wait on slow third-party scripts for more than 3s */
      var started = false, once = function () { if (!started) { started = true; go(); } };
      if (d.readyState === 'complete') once(); else { addEventListener('load', once, { once: true }); setTimeout(once, 3000); }
    }
    var snd = $('#snd');
    if (snd) snd.addEventListener('click', function () {
      soundOn = !soundOn;
      if (hero) hero.setSound(soundOn);
      if (pdpSq) pdpSq.setSound(soundOn);
      snd.setAttribute('aria-pressed', soundOn); snd.setAttribute('aria-label', soundOn ? 'Sound on' : 'Sound off');
      $('#sndw').style.opacity = soundOn ? 1 : 0;
    });
  })();

  /* ---------------------------------------------------------------- PDP */
  var pdpSq = null;
  var pdpEl = $('[data-pdp]'), pdpData = $('#pdpData');
  if (pdpEl && pdpData) (function () {
    var data = JSON.parse(pdpData.textContent);
    var cur = data.current, qty = 1;
    var gal = $('#gal'), add3d = $('#v3d'), vPhoto = $('#vPhoto'), atc = $('#pdpAdd'), form = $('[data-pdp-form]');
    var item = function (h) { return data.items[h]; };
    var first = item(cur);
    if (first && first.priceFmt) moneyPrefix = first.priceFmt.replace(/[\d.,\s]+$/, '') || moneyPrefix;
    function label() {
      var p = item(cur); if (!atc || !p) return;
      if (!p.available) { atc.disabled = true; atc.type = 'button'; atc.textContent = 'Sold out'; return; }
      atc.disabled = false; atc.type = 'submit';
      atc.textContent = 'Add to bag — ' + fmt(p.price * qty);
    }
    function view(v) {
      var three = v === '3d';
      gal.classList.toggle('three', three);
      vPhoto.setAttribute('aria-pressed', !three); add3d.setAttribute('aria-pressed', three);
      if (three && !pdpSq) {
        var p = item(cur);
        squish().then(function (m) {
          if (!gal.classList.contains('three') || pdpSq) return;
          pdpSq = m.createSquishy($('#pdpStage'), { toy: m.toyForHandle(cur), variant: cur, bg: p.tint, sound: soundOn,
            onError: function () { toast('The 3D view could not load'); view('photo'); } });
        }).catch(function () { toast('The 3D view could not load'); view('photo'); });
      }
      if (!three && pdpSq) { pdpSq.destroy(); pdpSq = null; }
    }
    function setPdp(h) {
      var p = item(h); if (!p) return false;
      var prev = cur; cur = h;
      var img = $('#pdpImg');
      if (img && p.img) { img.srcset = p.srcset || ''; img.src = p.img; img.alt = p.alt; }
      var th = $('.thumbs', gal); if (th) th.remove();
      gal.style.background = p.tint;
      $('#pdpTitle').innerHTML = esc(p.shape) + (p.colour ? '<span class="vh"> — ' + esc(p.colour) + '</span>' : '');
      var col = $('#pdpCol'); if (col) col.textContent = p.colour;
      var crumb = $('.crumb [aria-current]'); if (crumb) crumb.textContent = p.title;
      var was = item(prev); if (was && was.title && p.title) d.title = d.title.replace(was.title, p.title);
      var no = $('#pdpNo'); if (no && p.no) no.textContent = 'No. ' + p.no;
      $('#pdpPrice').innerHTML = esc(p.priceFmt) + (p.compareFmt ? ' <s>' + esc(p.compareFmt) + '</s>' : '');
      $$('#pdpOpts [data-h]').forEach(function (a) { a.setAttribute('aria-pressed', a.getAttribute('data-h') === h); });
      var vid = $('#pdpVid'); if (vid) vid.value = p.vid;
      var qb = $('.qty', form); if (qb) qb.hidden = !p.available;
      label();
      add3d.hidden = !p.has3d;
      if (!p.has3d) view('photo');
      else if (pdpSq) { pdpSq.setVariant(h); pdpSq.setBg(p.tint); }
      if (history.replaceState) history.replaceState(null, '', p.url);
      return true;
    }
    var opts = $('#pdpOpts');
    if (opts) opts.addEventListener('click', function (e) {
      var a = e.target.closest('[data-h]'); if (!a) return;
      if (setPdp(a.getAttribute('data-h'))) e.preventDefault();
    });
    vPhoto.addEventListener('click', function () { view('photo'); });
    add3d.addEventListener('click', function () { view('3d'); });
    var setQty = function (n) { qty = Math.max(1, Math.min(9, n)); $('#qv').textContent = qty; $('#pdpQty').value = qty; label(); };
    var qm = $('#qm'), qp = $('#qp');
    if (qm) qm.addEventListener('click', function () { setQty(qty - 1); });
    if (qp) qp.addEventListener('click', function () { setQty(qty + 1); });
    var thumbs = $('.thumbs', gal);
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-src]'); if (!b) return;
      view('photo');
      var img = $('#pdpImg'); img.srcset = ''; img.src = b.getAttribute('data-src'); img.alt = b.getAttribute('data-alt');
      $$('[data-src]', thumbs).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var p = item(cur); if (!p || !p.available) return;
      var vid = $('#pdpVid');
      atc.disabled = true;
      add([{ id: +(vid ? vid.value : p.vid), quantity: qty }]).then(function () { atc.disabled = false; label(); }, function () { atc.disabled = false; });
    });
  })();

  /* ---------------------------------------------------------------- set builder */
  var pick = $('#pickgrid');
  if (pick) (function () {
    var set = [], slots = $('#slots'), msg = $('#setMsg'), btn = $('#setAdd');
    var anyPrice = $('.price'); /* a Liquid-formatted price, for the currency glyph */
    if (anyPrice) moneyPrefix = anyPrice.textContent.trim().replace(/^From\s+/, '').replace(/[\d.,\s].*$/, '') || moneyPrefix;
    function render() {
      slots.textContent = '';
      for (var i = 0; i < 3; i++) {
        var s = d.createElement('div'); s.className = 'slot';
        var b = set[i];
        if (b) {
          var src = $('img', b);
          if (src) { var im = d.createElement('img'); im.src = src.currentSrc || src.src; im.alt = ''; s.appendChild(im); }
          var x = d.createElement('button'); x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', 'Remove'); x.setAttribute('data-rm', b.getAttribute('data-h'));
          s.appendChild(x);
        }
        slots.appendChild(s);
      }
      $$('.pick', pick).forEach(function (p) { p.setAttribute('aria-pressed', set.indexOf(p) > -1); });
      $('#progI').style.width = (set.length / 3 * 100) + '%';
      var total = set.reduce(function (n, b) { return n + (+b.getAttribute('data-price') || 0); }, 0);
      msg.textContent = set.length === 3 ? msg.getAttribute('data-done').replace('[total]', fmt(total)) : msg.getAttribute('data-pick').replace('[n]', 3 - set.length);
      btn.disabled = set.length !== 3;
    }
    pick.addEventListener('click', function (e) {
      var b = e.target.closest('.pick'); if (!b) return;
      var i = set.indexOf(b);
      if (i > -1) set.splice(i, 1); else if (set.length < 3) set.push(b);
      render();
    });
    slots.addEventListener('click', function (e) {
      var x = e.target.closest('[data-rm]'); if (!x) return;
      set = set.filter(function (b) { return b.getAttribute('data-h') !== x.getAttribute('data-rm'); });
      render();
    });
    btn.addEventListener('click', function () {
      if (set.length !== 3) return;
      btn.disabled = true;
      add(set.map(function (b) { return { id: +b.getAttribute('data-vid'), quantity: 1 }; }), { msg: 'Set of 3 added to your bag' })
        .then(function () { set = []; render(); }, function () { btn.disabled = false; });
    });
    render();
  })();

  /* ---------------------------------------------------------------- reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.15 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else $$('.reveal').forEach(function (el) { el.classList.add('in'); });
})();
